module.exports = __webpack_public_path__ + "1d6945359dc369cd09fa2406ed237f5e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/protherm@3x.png
 ** module id = 194
 ** module chunks = 0
 **/